import { UXComponent } from './component.js';
export default class Sidebar extends UXComponent {
    constructor() {
        super({ visible: false });
        this.reset();
    }
    reset() {
        this.enableToggle();
        this.setForceLargeScreenDisplay(false);
        super.reset({ visible: false });
    }
    isToggleAllowed() {
        return this.allowToggle;
    }
    enableToggle() {
        this.allowToggle = true;
    }
    disableToggle() {
        this.allowToggle = false;
    }
    setForceLargeScreenDisplay(isForced) {
        this.forceLargeScreenDisplay = isForced;
    }
    isLargeScreenDisplayForced() {
        return this.forceLargeScreenDisplay;
    }
    onSidebarVisibilityChange(callback) {
        this.listeners.push(callback);
    }
}
//# sourceMappingURL=sidebar.js.map